import { createReducer } from 'redux-act'
import u from 'updeep'

import { receive } from 'actions/authentication'

const initialState = {
  id: '',
  step: 'auth',
  type: '',
  data: {
    phone: '',
    code: '',
    email: '',
    first_name: '',
    last_name: '',
    guests: 0,
    language: '',
    ui_language: '',
    note: '',
    start: '',
    coupon_code: '',
  },
}

export default createReducer({
  [receive]: (state, payload) => {
    const { response, step } = payload
    const data = response
    return u({ data, step }, state)
  },
}, initialState)
